import script from "./HomeSettingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeSettingPage.vue?vue&type=script&setup=true&lang=js"

import "./HomeSettingPage.vue?vue&type=style&index=0&id=78cbeba2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78cbeba2"]])

export default __exports__